import * as annotationEvents from './annotation-events';
import * as viewerEvents from './viewer-events';

export const annotationEventOptions = {
    listenOn: Object.values(annotationEvents)
};

export const viewerEventOptions = {
    listenOn: Object.values(viewerEvents),
    enableFilePreviewEvents: true,
    enablePDFAnalytics: false
};
